// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"e6529ead","453":"dcc1ae14"}[chunkId] + ".chunk.js";
};